import React, { ReactNode } from 'react';
import './ScrollableArea.module.css';
type Props = {
  vertical: boolean;
  horizontal: boolean;
  width: string;
  height: string;
  children: ReactNode;
  border: string;
  backgroundColor?:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple'
    | 'inherit';
};

const ScrollableArea = ({
  children,
  vertical,
  horizontal,
  width,
  height,
  border,
  backgroundColor,
}: Props) => {
  return (
    <div
      style={{
        overflowX: horizontal ? 'scroll' : 'visible',
        overflowY: vertical ? 'scroll' : 'visible',
        width,
        height,
        maxWidth: width,
        maxHeight: height,
        border,
        padding: 'none',
        backgroundColor,
      }}
    >
      {children}
    </div>
  );
};

export default ScrollableArea;
